import { styled } from "@linaria/react";
import { COLOR_BLACK, COLOR_BLUE_DARK, FOOTER_HEIGHT, SIZE_M } from "../../constants";
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "coqgnfi"
});
const StyledAnchor = /*#__PURE__*/styled("a")({
  name: "StyledAnchor",
  class: "s1mxhqyx"
});

const getCurrentYear = () => {
  return new Date().getFullYear();
};

function Footer(): JSX.Element {
  return <Container>
      &copy; {getCurrentYear()} Fiberplane BV. All rights reserved.{" "}
      <StyledAnchor href="/privacy">Privacy policy</StyledAnchor>
    </Container>;
}

export default Footer;

require("../../../.linaria-cache/src/components/footer/index.linaria.module.css");